__turbopack_context__.v({
  "certBottom": "CertCard-module-scss-module__-iEzeq__certBottom",
  "customButton": "CertCard-module-scss-module__-iEzeq__customButton",
  "dislayEnrollNow": "CertCard-module-scss-module__-iEzeq__dislayEnrollNow",
  "hideEnrollNow": "CertCard-module-scss-module__-iEzeq__hideEnrollNow",
  "progCard": "CertCard-module-scss-module__-iEzeq__progCard",
  "progCard-bg2": "CertCard-module-scss-module__-iEzeq__progCard-bg2",
  "progCardBlock": "CertCard-module-scss-module__-iEzeq__progCardBlock",
  "progCardDetails": "CertCard-module-scss-module__-iEzeq__progCardDetails",
  "progHeading": "CertCard-module-scss-module__-iEzeq__progHeading",
  "progIcon": "CertCard-module-scss-module__-iEzeq__progIcon",
  "progImg": "CertCard-module-scss-module__-iEzeq__progImg",
  "progInfo": "CertCard-module-scss-module__-iEzeq__progInfo",
  "progMain": "CertCard-module-scss-module__-iEzeq__progMain",
});
